var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileDefualt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.1992,
    cy: 24,
    r: 24,
    fill: "#DEE2E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1808_10635",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.6992,
    y: 12,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1808_10635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6992 23.6923C23.7338 23.6923 22.9092 23.3503 22.2252 22.6664C21.5412 21.9824 21.1992 21.1577 21.1992 20.1924C21.1992 19.227 21.5412 18.4023 22.2252 17.7183C22.9092 17.0344 23.7338 16.6924 24.6992 16.6924C25.6646 16.6924 26.4892 17.0344 27.1732 17.7183C27.8572 18.4023 28.1992 19.227 28.1992 20.1924C28.1992 21.1577 27.8572 21.9824 27.1732 22.6664C26.4892 23.3503 25.6646 23.6923 24.6992 23.6923ZM17.1992 29.7885V29.0846C17.1992 28.5949 17.3322 28.1414 17.5983 27.7241C17.8643 27.3068 18.2197 26.986 18.6646 26.7616C19.6531 26.277 20.6502 25.9135 21.6559 25.6712C22.6617 25.4289 23.6761 25.3078 24.6992 25.3078C25.7223 25.3078 26.7367 25.4289 27.7424 25.6712C28.7482 25.9135 29.7453 26.277 30.7338 26.7616C31.1787 26.986 31.5341 27.3068 31.8001 27.7241C32.0662 28.1414 32.1992 28.5949 32.1992 29.0846V29.7885C32.1992 30.2103 32.0514 30.5689 31.7559 30.8644C31.4604 31.1599 31.1018 31.3077 30.68 31.3077H18.7184C18.2966 31.3077 17.938 31.1599 17.6425 30.8644C17.347 30.5689 17.1992 30.2103 17.1992 29.7885Z",
    fill: "#6C757D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileDefualt);
export default __webpack_public_path__ + "static/media/UserProfileDefualt.38d92dcd01eebb54b4b8e1779150ffd6.svg";
export { ForwardRef as ReactComponent };